// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".flight-map-container[data-v-557e3d1a]{width:100%;height:100%}.map-container[data-v-557e3d1a]{width:100%;height:145px;border-radius:8px;overflow:hidden}[data-v-557e3d1a] .plane-marker{background:none;border:none;font-size:20px;text-align:center;line-height:20px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
